import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  getStockByGoodsIds (params) {
    return axios.post(global.IMS_STOCK + '/info/findStockQuantityList', params)
  },
  uploadExcel () {
    return axios.post(global.IMS_STOCK + '/info/uploadStock')
  },
  exportExcel () {
    return axios.post(global.IMS_STOCK + '/info/export')
  },
  stockUpdate (params) {
    return axios.post(global.IMS_STOCK + '/info/updateStockQuantity', params)
  },
  insertInStock (params) { // 新增入库单
    return axios.post(global.IMS_ORDER + '/stock/insertInStock', params)
  },
  insertOutStock (params) { // 新增出库单
    return axios.post(global.IMS_ORDER + '/stock/insertOutStock', params)
  },
  verifyInStock (params) { // 审核入库单
    return axios.post(global.IMS_ORDER + '/stock/verifyInStock', params)
  },
  verifyOutStock (params) { // 审核出库单
    return axios.post(global.IMS_ORDER + '/stock/verifyOutStock', params)
  },
  deleteStockIn (params) { // 删除入库单
    return axios.post(global.IMS_ORDER + '/stock/deleteStockIn', params)
  },
  deleteStockOut (params) { // 删除出库单
    return axios.post(global.IMS_ORDER + '/stock/deleteStockOut', params)
  },
  stockInDetail (params) { // 入库单详情
    return axios.post(global.IMS_ORDER + '/stock/findStockInDetails', params)
  },
  stockOutDetail (params) { // 出库单详情
    return axios.post(global.IMS_ORDER + '/stock/findStockOutDetails', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/ims/stock.js